<div [class]="mode() === 'slider' ? 'grid-box-slider' : 'grid-box'">
    @for (section of sections(); track section.id) {
        <a [routerLink]="['/menu-list', section.id]" [attr.data-testid]="'super-section-' + section.id">
            <div class="img-wrap img-shimmer">
                <img [defaultImage]="placeholderImage()" [lazyLoad]="section.logo_url" [errorImage]="placeholderImage()">
            </div>
            <span>{{ section.name }}</span>
        </a>
    }
</div>
